import { render, staticRenderFns } from "./zIndex.vue?vue&type=template&id=60b1052c&scoped=true"
import script from "./zIndex.vue?vue&type=script&lang=js"
export * from "./zIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1052c",
  null
  
)

export default component.exports